import { createRoute,Outlet } from '@tanstack/react-router'

import { rootRoute } from '../root'

export const blogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'blogs',
  component: Outlet,
})
